(function () {
  var CFG = window.CartAccessGuard || {};
  var ROOT =
    (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  var validating = false;
  var scheduled = null;
  var suppressNextMutationCheck = false;

  function log() {
    if (!CFG.debug) return;
    console.log.apply(console, ["[CartAccessGuard]"].concat([].slice.call(arguments)));
  }

  function warn() {
    console.warn.apply(console, ["[CartAccessGuard]"].concat([].slice.call(arguments)));
  }

  function getCustomerTags() {
    return Array.isArray(CFG.customer && CFG.customer.tags) ? CFG.customer.tags : [];
  }

  function hasAllowedAccess() {
    var customerTags = getCustomerTags();
    var allowedTags = Array.isArray(CFG.allowedCustomerTags) ? CFG.allowedCustomerTags : [];

    return allowedTags.some(function (tag) {
      return customerTags.indexOf(tag) !== -1;
    });
  }

  function isCartMutationUrl(url) {
    if (!url || typeof url !== "string") return false;

    return (
      url.indexOf("/cart/add") !== -1 ||
      url.indexOf("/cart/change") !== -1 ||
      url.indexOf("/cart/update") !== -1 ||
      url.indexOf("/cart/clear") !== -1
    );
  }

  async function fetchCart() {
    var res = await fetch(ROOT + "cart.js", {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    });

    if (!res.ok) {
      throw new Error("Failed to fetch cart.js");
    }

    return await res.json();
  }

  async function clearCart() {
    suppressNextMutationCheck = true;

    var res = await fetch(ROOT + "cart/clear.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    });

    if (!res.ok) {
      suppressNextMutationCheck = false;
      throw new Error("Failed to clear cart");
    }

    return await res.json();
  }

  function showBlockedMessage() {
    log(CFG.messages && CFG.messages.blocked);

    if (CFG.debug) {
      alert((CFG.messages && CFG.messages.blocked) || "Cart blocked.");
    }
  }

  async function validateCart(source) {
    if (validating) {
      log("Validation skipped because one is already running:", source);
      return;
    }

    validating = true;

    try {
      var cart = await fetchCart();
      var itemCount = Number(cart && cart.item_count ? cart.item_count : 0);
      var allowed = hasAllowedAccess();

      log("Validation source:", source);
      log("Customer tags:", getCustomerTags());
      log("Cart item count:", itemCount);
      log("Has allowed access:", allowed);

      if (itemCount > 0 && !allowed) {
        warn("Customer lacks required access. Clearing cart now.");
        await clearCart();
        showBlockedMessage();

        setTimeout(function () {
          window.location.reload();
        }, 300);

        return;
      }

      log("Cart passed validation.");
    } catch (err) {
      console.error("[CartAccessGuard] Validation error:", err);
    } finally {
      validating = false;
    }
  }

  function scheduleValidation(source, delay) {
    if (scheduled) {
      clearTimeout(scheduled);
    }

    scheduled = setTimeout(function () {
      validateCart(source);
    }, delay || 250);
  }

  function interceptFetch() {
    if (!window.fetch) return;

    var originalFetch = window.fetch;

    window.fetch = async function () {
      var args = arguments;
      var request = args[0];
      var url = typeof request === "string" ? request : (request && request.url) || "";

      var response = await originalFetch.apply(this, args);

      try {
        if (isCartMutationUrl(url)) {
          if (suppressNextMutationCheck && url.indexOf("/cart/clear") !== -1) {
            suppressNextMutationCheck = false;
            log("Ignoring validation triggered by our own cart clear.");
          } else {
            log("Detected fetch cart mutation:", url);
            scheduleValidation("fetch:" + url, 250);
          }
        }
      } catch (e) {
        console.error("[CartAccessGuard] fetch intercept error:", e);
      }

      return response;
    };
  }

  function interceptXHR() {
    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this._cartAccessGuardUrl = url;
      return originalOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      this.addEventListener("load", function () {
        try {
          var url = this._cartAccessGuardUrl || "";

          if (isCartMutationUrl(url)) {
            if (suppressNextMutationCheck && url.indexOf("/cart/clear") !== -1) {
              suppressNextMutationCheck = false;
              log("Ignoring XHR validation triggered by our own cart clear.");
            } else {
              log("Detected XHR cart mutation:", url);
              scheduleValidation("xhr:" + url, 250);
            }
          }
        } catch (e) {
          console.error("[CartAccessGuard] XHR intercept error:", e);
        }
      });

      return originalSend.apply(this, arguments);
    };
  }

  function interceptForms() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form) return;

      var action = form.getAttribute("action") || "";

      if (action.indexOf("/cart/add") !== -1) {
        log("Detected add-to-cart form submit");
        scheduleValidation("form-submit", 500);
      }
    });
  }

  function interceptCheckout() {
    document.addEventListener("click", function (event) {
      var button = event.target.closest(
        'button[name="checkout"], input[name="checkout"], a[href*="/checkout"]'
      );

      if (!button) return;

      event.preventDefault();

      validateCart("checkout-click").then(async function () {
        try {
          var cart = await fetchCart();

          if (Number(cart && cart.item_count ? cart.item_count : 0) > 0) {
            window.location.href = ROOT + "checkout";
          } else {
            log("Checkout blocked because cart is empty after validation.");
          }
        } catch (err) {
          console.error("[CartAccessGuard] Checkout validation error:", err);
        }
      });
    });
  }

  function init() {
    log("Initializing cart access guard");
    interceptFetch();
    interceptXHR();
    interceptForms();
    interceptCheckout();
    validateCart("page-load");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();